import React from 'react';
import { Typography, Row, Col, Image, Divider } from 'antd';
import '../../../Styles/ResearchLabs.css';  // Import the CSS for styling
import scopeImage from '../../../Assets/ResearchLabs/Common/AI Domains/SDSSL-Domain-AI.png';

const { Title, Paragraph } = Typography;

const ScopeSection = () => {
  return (
    <section className="scope-section">
      <div className="scope-section-inner">
        <Row gutter={[72, 40]} align="middle" justify="space-between">
          <Col xs={24} md={15}>
            <Title level={2} className="scope-title">Scope</Title>
            <Divider className="ncgsa-divider" />
            <Paragraph className="scope-description">
              The Spatial Decision Support System Lab (SDSSL) is established at the Balochistan University of 
              Information Technology, Engineering and Management Sciences (BUITEMS), Quetta, and the Sardar 
              Bahadur Khan Women University (SBKWU), Quetta with BUITEMS as the primary lab. The SDSSL lab 
              focuses on three different domains including Geo-Health, Geo-Forensics, and on Minerals Inventory. 
              In the Geo-Health domain, the lab focuses on research techniques for tracking and process mining 
              using a novel approach to SDSS. Specifically, the approach is focused on improving the outreach of 
              health services in general and coverage of immunization in particular that largely rely upon efficient 
              record management and accurate predictions. Under the Geo-Forensics domain, our focus is to improve 
              the digital forensics processes with the help of spatial data mapping. The increasing number of cybercrimes 
              and digital frauds are becoming a threat to society that can be dealt with using advanced technology. 
              In this regard GIS mapping of an incident could prove to be an essential tool. The Minerals inventory 
              focuses on GIS mapping of minerals of Balochistan. With the use of remote sensing techniques for the 
              mineral exploration, evaluation, and formal quantification of naturally occurring materials of 
              Balochistan, we are focused to improve the management of mineral inventories.
            </Paragraph>
          </Col>
          <Col xs={24} md={9}>
            <div className="scope-image-wrap">
              <Image src={scopeImage} alt="Digital globe representing spatial decision support" className="scope-image" preview={false} />
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default ScopeSection;
